import { useState, useCallback } from "react";

interface ApiErrorState {
  isVisible: boolean;
  message: string;
}

const DEFAULT_ERROR_MESSAGE =
  "Sorry, we're experiencing technical difficulties and can't send your verification code. Please try again later. If the issue continues, please call our Technical Support team at 1-844-603-0035 (TTY: 711), Monday through Friday, from 8 a.m. to 8 p.m. ET, to report the issue.";

export const useApiError = () => {
  const [errorState, setErrorState] = useState<ApiErrorState>({
    isVisible: false,
    message: DEFAULT_ERROR_MESSAGE,
  });

  const showError = useCallback((message?: string) => {
    setErrorState({
      isVisible: true,
      message: message || DEFAULT_ERROR_MESSAGE,
    });
  }, []);

  const hideError = useCallback(() => {
    setErrorState((prev) => ({
      ...prev,
      isVisible: false,
    }));
  }, []);

  return {
    errorState,
    showError,
    hideError,
  };
};
